import CMSCard from "components/common/cards/CMSCards"
import { NoDataAndWentWrongHandler, WentWrong } from "components/common/noData"
import PropTypes from "prop-types"
import React from "react"
import { formatCurrency } from "utils"

import CMSTypography, {
  StandardTypographyTypes
} from "../typography/CMSTypography"

/**
 * Renders single cost optimization recommendation card based on the metric provided
 * @example
 * const metric = {
 *  count: 326.01,
 *  error: false,
 *  title: "Compute Rightsizing"
 * }
 * return (
 *  <CostOptimizationCard
 *    metric={metric}
 *    setType={setDraweType}
 *    setIsOpen={setIsDrawerOpen}
 *    currencySymbol={currencySymbol}
 *    fxRate={fxRate}
 *  />
 * )
 */
function CostOptimizationCard({
  metric,
  setType,
  setIsOpen,
  currencySymbol,
  fxRate
}) {
  const onClickHandler = () => {
    setType(metric.title)
    setIsOpen(true)
  }
  return (
    <CMSCard clickable onClick={onClickHandler}>
      <div className="d-flex justify-content-between align-items-center">
        <NoDataAndWentWrongHandler
          wentWrongCondition={metric.error}
          wentWrongComponent={
            <WentWrong imageClassName="w-20" className="col" />
          }
        >
          <div>
            <div className="costOptIconDiv">
              <p className="costOptIcon">{metric.title[0]}</p>
            </div>
            <div className="mt-2">
              <CMSTypography type={StandardTypographyTypes.cardHeading}>
                {" "}
                {metric.title}
              </CMSTypography>
            </div>
          </div>
          <CMSTypography type={StandardTypographyTypes.subHeading}>
            {formatCurrency(metric.count, currencySymbol, fxRate)}
          </CMSTypography>
        </NoDataAndWentWrongHandler>
      </div>
    </CMSCard>
  )
}

CostOptimizationCard.propTypes = {
  // metric to render the card data
  metric: PropTypes.object,
  // handler to set drawer type
  setType: PropTypes.func,
  // handler to open up the drawer
  setIsOpen: PropTypes.func,
  // currency symbol like $ or ₹
  currencySymbol: PropTypes.string,
  fxRate: PropTypes.number
}

export default CostOptimizationCard
